export default "__VITE_ASSET__BJzV7$EL__"